<script>
import {getStaticElementByType} from "../calendarUtils";

export default {
    name: "calendar-thumbnail",
    props: {
        element: {
            /** @type CalendarPublishElement */
            type: Object,
            required: true
        },
        width: Number
    },
    computed: {
        kind() {
            return getStaticElementByType(this.element.data.type).eicon;
        },
        thumbnailStyle() {
            return {
                width: `${this.width}px`,
                height: `${this.width * 0.6}px`
            };
        }
    }
}
</script>

<template>
    <div class="calendar-thumbnail-wrapper" :style="thumbnailStyle">
        <img v-if="element.data.backgroundImage"
             class="calendar-thumbnail"
             :src="element.data.backgroundImage"
             :alt="element.data.name"
        />
        <div v-else class="calendar-thumbnail-fallback">
            <eicon :kind="kind" :style="{fontSize: '80px'}" class="eicon-center"/>
        </div>
    </div>
</template>

<style scoped>
.calendar-thumbnail-wrapper {
    position: relative;
    overflow: hidden;
}

.calendar-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.calendar-thumbnail-fallback {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
